import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { EDIT_PROFILE,GET_PROFILE } from "./actionTypes";
import { getProfileSuccess,getProfileFail,profileSuccess, profileError } from "./actions";
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeProfile,
  postJwtProfile,
  getProfileData,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

function* editProfile({ payload: { user } }) {

  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.editProfileAPI,
        user.username,
        user.idx
      );
      yield put(profileSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtProfile, "/post-jwt-profile", {
        username: user.username,
        idx: user.idx,
      });
      yield put(profileSuccess(response));
    } else if (process.env.REACT_APP_API_URL) {
      const response = yield call(postFakeProfile, user);
      yield put(profileSuccess(response));
    }
  } catch (error) {
    yield put(profileError(error));
  }
}

function* getProfile({payload : user}) {
  try {
    const response = yield call(getProfileData,user)
    yield put(getProfileSuccess(response))
  } catch (error) {
    yield put(getProfileFail(error))
  }
}


export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile);
}

export function* watchProfileGet() {
  yield takeEvery(GET_PROFILE, getProfile);
}

function* ProfileSaga() {
  yield all([fork(watchProfile)]);
  yield all([fork(watchProfileGet)]);
}

export default ProfileSaga;
